import { ShoppingBag, Clock, Bell, Instagram, Twitter, Facebook } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useState } from 'react';
import { toast } from 'sonner';

// MOCGA brand images
const MOCGA_LOGO = 'https://customer-assets.emergentagent.com/job_councillor-watch/artifacts/4ea27emo_Fashion%20Retailer%20Logo%20-%20mocga.uk_20251201_030015_0000.png';
const MOCGA_BANNER = 'https://customer-assets.emergentagent.com/job_councillor-watch/artifacts/6iz9j6eq_MAKE%20OUR%20COUNTRY_20251130_164451_0000.png';

export default function ShopPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleNotify = (e) => {
    e.preventDefault();
    if (email) {
      // In production, this would submit to a backend
      setSubmitted(true);
      toast.success("You'll be notified when the shop launches!");
    }
  };

  return (
    <div className="min-h-screen bg-black" data-testid="shop-page">
      {/* Background */}
      <div className="fixed inset-0 opacity-20">
        <img 
          src={MOCGA_BANNER} 
          alt="" 
          className="w-full h-full object-cover"
        />
      </div>
      
      {/* Content */}
      <div className="relative min-h-screen flex flex-col items-center justify-center px-4 py-20">
        {/* Logo */}
        <img 
          src={MOCGA_LOGO}
          alt="MOCGA Logo"
          className="h-20 sm:h-28 md:h-36 mb-8 object-contain"
        />
        
        {/* Coming Soon Badge */}
        <div className="inline-flex items-center gap-2 bg-amber-500 text-black px-4 py-2 rounded-full font-bold text-sm mb-6">
          <Clock className="h-4 w-4" />
          COMING SOON
        </div>
        
        {/* Title */}
        <h1 className="font-serif text-4xl sm:text-5xl md:text-7xl text-white text-center font-light mb-4">
          Make Our Country<br />
          <span className="font-medium">Great Again</span>
        </h1>
        
        {/* Subtitle */}
        <p className="text-slate-400 text-center max-w-md mb-10 text-sm sm:text-base">
          Premium British streetwear with a message. 
          Our shop is being updated with new products. Check back soon!
        </p>
        
        {/* Notification Signup */}
        {!submitted ? (
          <form onSubmit={handleNotify} className="w-full max-w-md mb-12">
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder:text-slate-500 focus:outline-none focus:border-amber-500"
                required
              />
              <Button 
                type="submit"
                className="bg-amber-500 hover:bg-amber-600 text-black font-bold px-6 py-3"
              >
                <Bell className="h-4 w-4 mr-2" />
                Notify Me
              </Button>
            </div>
          </form>
        ) : (
          <div className="bg-emerald-500/20 border border-emerald-500/30 text-emerald-400 px-6 py-4 rounded-lg mb-12 text-center">
            <p className="font-medium">You're on the list!</p>
            <p className="text-sm text-emerald-400/70">We'll email you when the shop launches.</p>
          </div>
        )}
        
        {/* Social Links */}
        <div className="text-center">
          <p className="text-sm text-slate-500 mb-4">Follow MOCGA for updates</p>
          <div className="flex justify-center gap-4">
            <a 
              href="https://instagram.com/mocga.uk" 
              target="_blank" 
              rel="noopener noreferrer"
              className="p-3 bg-white/10 rounded-full text-white hover:bg-white/20 transition-colors"
              aria-label="Instagram"
            >
              <Instagram className="h-5 w-5" />
            </a>
            <a 
              href="https://twitter.com/mocgauk" 
              target="_blank" 
              rel="noopener noreferrer"
              className="p-3 bg-white/10 rounded-full text-white hover:bg-white/20 transition-colors"
              aria-label="Twitter"
            >
              <Twitter className="h-5 w-5" />
            </a>
            <a 
              href="https://facebook.com/mocga.uk" 
              target="_blank" 
              rel="noopener noreferrer"
              className="p-3 bg-white/10 rounded-full text-white hover:bg-white/20 transition-colors"
              aria-label="Facebook"
            >
              <Facebook className="h-5 w-5" />
            </a>
          </div>
        </div>
        
        {/* Banner Image Preview */}
        <div className="mt-16 w-full max-w-2xl">
          <img 
            src={MOCGA_BANNER}
            alt="MOCGA Collection Preview"
            className="w-full h-auto rounded-xl opacity-80"
          />
        </div>
      </div>
    </div>
  );
}
